/** Contenu FR de la home chauffeur (repris à l'identique de l'existant). */
import type { ChauffeurHubData } from "./hubDict";

export const HUB_FR: ChauffeurHubData = {
  hero: {
    eyebrow: "Chauffeur privé à Cannes",
    title: "Chauffeur privé & VTC à Cannes",
    subtitle:
      "Trajets premium sur la Côte d’Azur: transferts, événements, business.",
    ctaPrimary: { href: "/reservation", label: "Réserver" },
    ctaSecondary: { href: "/contact", label: "Demander un devis" },
    trustLine:
      "Confirmation immédiate • Paiement sécurisé • Réponse en moins d'une minute",
    chips: [
      "Accueil aéroport/hôtel",
      "Coordination événements",
      "Support humain dédié",
    ],
    bookingTitle: "Réserver en 3 étapes",
    steps: [
      "Choisissez la date et l’heure de prise en charge",
      "Indiquez l’itinéraire ou le besoin (transfert, mise à dispo)",
      "Validation instantanée",
    ],
    bookingCta: "Réserver maintenant",
    bookingNote: "Aucun paiement requis pour débuter",
  },
  services: {
    eyebrow: "Services chauffeur privé",
    heading: "Services chauffeur haut de gamme",
    intro:
      "Des prestations premium pensées pour vos besoins à Cannes et sur toute la Côte d’Azur, avec ponctualité, confort et discrétion.",
    mostRequested: "Service le plus demandé",
    priorityBadge: "Priorite ponctualite et coordination",
    points: ["Reponse rapide", "Accueil premium", "Service 7j/7"],
    items: [
      {
        title: "Transferts aéroports",
        text: "Arrivées/départs optimisés avec suivi de vol et coordination précise des horaires.",
        icon: "ph:airplane-tilt",
      },
      {
        title: "Mise à disposition",
        text: "Chauffeur privé à l'heure, demi-journée ou journée complete selon votre planning.",
        icon: "ph:clock",
      },
      {
        title: "Événements",
        text: "Dispositifs VIP, navettes et gestion des flux sur Cannes, Monaco et Nice.",
        icon: "ph:calendar-check",
      },
      {
        title: "Business",
        text: "Roadshows, rendez-vous d'affaires et déplacements corporate en toute discrétion.",
        icon: "ph:briefcase",
      },
      {
        title: "Mariages",
        text: "Parcours cérémonie/réception millimètre avec service premium pour les convives.",
        icon: "ph:heart",
      },
      {
        title: "Excursions",
        text: "Parcours scenic et itinéraires privés sur la Côte d'Azur et Riviera italienne.",
        icon: "ph:mountains",
      },
    ],
  },
  indicators: {
    heading: "Indicateurs de service et promesse KS Rent Services",
    items: [
      {
        label: "Confirmation",
        value: "Rapide",
        text: "retour en priorité sur les demandes qualifiées",
      },
      {
        label: "Disponibilité",
        value: "7j/7",
        text: "prise en charge anticipée et horaires étendus",
      },
      {
        label: "Zone active",
        value: "Cannes - Monaco - Nice",
        text: "extensions Riviera italienne sur demande",
      },
      {
        label: "Positionnement",
        value: "Premium discret",
        text: "service sobre, fluide et ponctuel",
      },
    ],
  },
  motion: {
    eyebrow: "Engagement opérationnel",
    heading: "Notre méthode de service sur la Côte d'Azur",
    text: "Chez KS Rent Services, chaque mission est cadrée avec un interlocuteur unique, un suivi horaire clair et une exécution terrain fiable de Cannes à Monaco, Nice et Sophia.",
    badge: "Service chauffeur premium",
    signatureText:
      "Chauffeur privé à Cannes et sur la Côte d'Azur: transferts, business, événements et mise à disposition avec un niveau de service constant.",
    leftAlt: "Expérience passager premium",
    rightAlt: "Transferts aéroports et héliports",
  },
  locations: {
    eyebrow: "Maillage territorial chauffeur",
    heading: "Zones desservies et itinéraires privilégiés",
    introPrefix:
      "Service de chauffeur privé basé à Cannes, desservant toute la Côte d’Azur jusqu’à Monaco. ",
    srPrefix: "Zones desservies: ",
    corridorsTitle: "Corridors prioritaires",
    corridorNote: "Départ flexible - confirmation structurée",
    corridorPrefix: "Cannes -> ",
    items: [
      {
        name: "Cannes",
        description:
          "base operationnelle et deploiement rapide pour toute demande locale",
      },
      {
        name: "Nice",
        description: "centre-ville, aéroport et quartiers affaires",
      },
      {
        name: "Antibes",
        description: "vieille ville, Juan-les-Pins et secteur événementiel",
      },
      { name: "Monaco", description: "principaute, hotels et lieux corporate" },
      {
        name: "Mandelieu",
        description: "liaisons residence, marina et rendez-vous pro",
      },
      {
        name: "Grasse",
        description: "trajets business et déplacements privés",
      },
      {
        name: "Saint-Tropez",
        description: "transferts premium saisonniers et week-end",
      },
      {
        name: "Menton",
        description: "deplacements longue distance Cote d'Azur est",
      },
      {
        name: "Milan",
        description: "sur demande pour besoins executives et événements",
      },
      {
        name: "Riviera italienne",
        description: "extension cohérente avec votre parcours principal",
      },
    ],
  },
  process: {
    heading: "Processus chauffeur en 4 etapes claires",
    intro:
      "Une methode simple pour eviter les allers-retours: vous exprimez le besoin, nous cadrons le service, nous confirmons, nous executons.",
    stepWord: "Étape",
    steps: [
      "Qualification du besoin: parcours, timing, priorites, nombre de passagers.",
      "Proposition de service: format, amplitude, options et contraintes terrain.",
      "Confirmation ecrite: point de rendez-vous, rappel logistique et consignes.",
      "Exécution : suivi actif jusqu'à la destination finale.",
    ],
    leftAlt: "Coordination chauffeur premium",
    rightAlt: "Accueil passager et suivi horaire",
  },
  seoContent: {
    eyebrow: "Informations utiles chauffeur",
    heading:
      "Chauffeur privé à Cannes : contenu utile pour comparer et décider",
    paragraphs: [
      "Notre service de chauffeur privé à Cannes répond aux besoins business, événementiels et privés avec un niveau de service stable : ponctualité, fluidité, discrétion.",
      "Vous obtenez une solution claire avant départ : format du service, cadre horaire, options utiles et niveau d'accompagnement adapté au contexte.",
      "Le but n'est pas seulement de transporter, mais de protéger votre agenda, votre image et votre confort passager sur chaque segment du trajet.",
    ],
    bullets: [
      "Prise en charge 7j/7 avec confirmation structurée",
      "Chauffeurs expérimentés, posture premium et discrète",
      "Parcours personnalisables sans complexifier la réservation",
      "Tarification claire et communication proactive",
    ],
    metrics: [
      { k: "Reponse moyenne", v: "< 15 min" },
      { k: "Disponibilite", v: "7j/7" },
      { k: "Zone active", v: "Cannes - Monaco - Nice" },
    ],
    whyTitle: "Pourquoi nous choisir",
    whyItems: [
      "Chauffeurs expérimentés et discrets",
      "Véhicules premium entretenus",
      "Réservation simple et confirmation rapide",
      "Service 24/7 au départ de Cannes",
    ],
  },
  atouts: {
    eyebrow: "Atouts transverses",
    heading: "Les points forts repris de nos services chauffeur",
    intro:
      "Des atouts concrets utilisés sur nos pages aéroport, événements, entreprise, Cannes, Côte d'Azur et services.",
    items: [
      {
        title: "Suivi de vol",
        text: "Ajustement en temps réel sur les arrivées sensibles.",
      },
      {
        title: "Chef de projet",
        text: "Coordination dédiée sur vos opérations événementielles.",
      },
      {
        title: "SLA & fiabilité",
        text: "Cadre de service clair pour les besoins entreprise.",
      },
      {
        title: "Accès événements",
        text: "Pilotage fluide pour congrès, salons et festivals.",
      },
      {
        title: "Connaissance locale",
        text: "Itinéraires adaptés sur toute la Côte d'Azur.",
      },
      {
        title: "Ponctualité 24/7",
        text: "Exécution régulière sur les demandes prioritaires.",
      },
    ],
  },
  faq: {
    eyebrow: "Questions fréquentes",
    heading: "FAQ chauffeur privé",
    items: [
      {
        q: "Quel est le bon moment pour réserver un chauffeur privé ?",
        a: "Le plus tot possible pour les périodes chargées. Pour une demande urgente, transmettez votre timing exact et nous confirmons la faisabilité rapidement.",
      },
      {
        q: "La mise à disposition est-elle adaptée aux journées business ?",
        a: "Oui. C'est le format le plus souple pour enchaînement de rendez-vous, itinéraire variable et ajustements en cours de journée.",
      },
      {
        q: "Pouvez-vous gérer un événement avec plusieurs points de collecte ?",
        a: "Oui, nous pouvons organiser un plan de prise en charge multi-points avec coordination opérationnelle pour garder un flux passager lisible.",
      },
      {
        q: "Quelle différence entre un taxi classique et ce service chauffeur ?",
        a: "Le service chauffeur est structure autour de votre parcours global, avec un niveau de personnalisation et de suivi plus élevé.",
      },
    ],
    asideEyebrow: "Réponse rapide",
    asideTitle: "Besoin d'une validation rapide avant réservation ?",
    asideText:
      "Notre équipe peut confirmer la faisabilité, le périmètre de service et le cadre de prise en charge sur vos demandes prioritaires.",
    asideBullets: [
      "Support 7j/7",
      "Accueil FR / EN",
      "Coordination événements & aéroports",
    ],
  },
  fleet: {
    eyebrow: "Notre flotte",
    heading: "Une page par véhicule de notre flotte VTC",
    intro:
      "Choisissez le véhicule adapté à votre trajet : berline d'affaires, berline de prestige, van 7 places, SUV de luxe, minibus VIP ou véhicule blindé.",
    links: [
      {
        label: "Berline avec chauffeur (Classe E)",
        href: "/chauffeur/berline-avec-chauffeur",
      },
      {
        label: "Mercedes Classe S avec chauffeur",
        href: "/chauffeur/classe-s-avec-chauffeur",
      },
      {
        label: "Van avec chauffeur — 7 places",
        href: "/chauffeur/van-avec-chauffeur",
      },
      {
        label: "Range Rover avec chauffeur — SUV",
        href: "/chauffeur/suv-avec-chauffeur",
      },
      {
        label: "Minibus VIP — jusqu'à 16 places",
        href: "/chauffeur/minibus-vip",
      },
      {
        label: "Chauffeur sécurité & véhicule blindé",
        href: "/chauffeur/chauffeur-securite",
      },
    ],
  },
  complementary: {
    heading: "Services complémentaires",
    intro:
      "Retrouvez les pages utiles pour comparer rapidement les services chauffeur, les excursions privées et la location de véhicules.",
    links: [
      { label: "Excursions privées sur la Côte d'Azur", href: "/excursions" },
      { label: "Location de véhicules premium", href: "/location/vehicules" },
      { label: "Chauffeur transfert aéroport", href: "/chauffeur/transferts" },
      {
        label: "Voiture de mariage à Cannes",
        href: "/chauffeur/voiture-mariage-cannes",
      },
      { label: "Réserver votre trajet en ligne", href: "/reservation" },
    ],
  },
  seo: {
    title: "Chauffeur privé à Cannes & VTC Côte d'Azur | KS Rent Services",
    description:
      "Chauffeur privé et VTC à Cannes : transferts aéroport, événements, business et mise à disposition sur toute la Côte d'Azur. Réservation simple, service 7j/7.",
    canonical: "/chauffeur",
  },
};
